import type { TranslationDictionary, TranslationNode } from './translation.model';

export function resolveTranslationKey(
  dictionary: TranslationDictionary,
  key: string,
): TranslationNode | undefined {
  return key
    .split('.')
    .reduce<TranslationNode | undefined>((node, segment) => {
      if (node && typeof node === 'object' && segment in node) {
        return (node as Record<string, TranslationNode>)[segment];
      }
      return undefined;
    }, dictionary);
}

export function interpolate(value: string, params: Record<string, string | number>): string {
  return value.replace(/\{\{(\w+)\}\}/g, (match, paramName: string) =>
    paramName in params ? String(params[paramName]) : match,
  );
}
